/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type MyAccountPage_viewer$ref = any;
export type queries_MyAccountPage_QueryVariables = {};
export type queries_MyAccountPage_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": MyAccountPage_viewer$ref;
    }) | null;
};
export type queries_MyAccountPage_Query = {
    readonly response: queries_MyAccountPage_QueryResponse;
    readonly variables: queries_MyAccountPage_QueryVariables;
};



/*
query queries_MyAccountPage_Query {
  viewer {
    id
    ...MyAccountPage_viewer
  }
}

fragment MyAccountPage_viewer on Viewer {
  id
  isLoggedIn
  ...FileUploadForm_viewer
  userInfo {
    profile {
      id
      image
      state
      personality
      summary
    }
    id
  }
  user {
    id
    ...ShopWithCeoDialog_user
    publicId
    userId
    password
    firstName
    lastName
    customUrl
    email
    mobilePhone
    role
    hasSSOAccount
    hasGoogleLogin
    hasFacebookLogin
    isResettingPassword
    permissions {
      id
      oneCommerce {
        id
        ceo {
          access
        }
      }
    }
    preferredCustomerCeoAccountId
    shoppingWithCeoUser {
      firstName
      userId
      id
    }
    profile {
      id
      image
      city
      state
      zip
      summary
    }
    shippingAddressDefault {
      id
      lastName
      firstName
      street
      addressLineOne
      addressLineTwo
      city
      state
      addressId
      zip
    }
    paymentDefault {
      id
      name
      expMonth
      expYear
      last4
      paymentId
    }
  }
}

fragment FileUploadForm_viewer on Viewer {
  id
  user {
    id
    userId
    profile {
      id
      image
    }
  }
}

fragment ShopWithCeoDialog_user on User {
  role
  id
  cart {
    id
    eventId
  }
  ...ShopWithCeoProfile_user
  ceo {
    id
    userId
    firstName
    disableJoinMyTeam
    lastName
    trinityDealerId
    profile {
      image
      summary
      city
      state
      zip
      id
    }
  }
}

fragment ShopWithCeoProfile_user on User {
  ...EventsDropDown_user
  shoppingWithCeoUser {
    userId
    firstName
    id
  }
}

fragment EventsDropDown_user on User {
  ...DropDownAutoComplete_user
}

fragment DropDownAutoComplete_user on User {
  ...AuthDialog_user
  id
  userId
  publicId
  permissions {
    id
    oneCommerce {
      id
      ceo {
        access
      }
    }
  }
  shoppingWithCeoUser {
    publicId
    id
  }
  DropDownAutoCompleteData: autoCompleteData(first: 25, ceoId: "none", searchCEOS: false, searchEvents: false, searchProducts: false) {
    edges {
      cursor
      node {
        id
        isCEO
        image
        ceoId
        isEvent
        isProduct
        routePath
        primaryLabel
        secondaryLabel
        productCategory
        __typename
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment AuthDialog_user on User {
  id
  role
  email
  lastName
  firstName
  hasSSOAccount
  shoppingWithCeoUser {
    userId
    id
  }
  cart {
    id
    eventId
    eventHostFirstName
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "image",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "city",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "state",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "zip",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "summary",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lastName",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstName",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "userId",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "publicId",
        "args": null,
        "storageKey": null
    } as any), v10 = [
        ({
            "kind": "Literal",
            "name": "ceoId",
            "value": "none",
            "type": "String"
        } as any),
        ({
            "kind": "Literal",
            "name": "first",
            "value": 25,
            "type": "Int"
        } as any),
        ({
            "kind": "Literal",
            "name": "searchCEOS",
            "value": false,
            "type": "Boolean"
        } as any),
        ({
            "kind": "Literal",
            "name": "searchEvents",
            "value": false,
            "type": "Boolean"
        } as any),
        ({
            "kind": "Literal",
            "name": "searchProducts",
            "value": false,
            "type": "Boolean"
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "queries_MyAccountPage_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "MyAccountPage_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "queries_MyAccountPage_Query",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isLoggedIn",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "permissions",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PermissionsType",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "oneCommerce",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "OneCommerceType",
                                            "plural": false,
                                            "selections": [
                                                (v0 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "ceo",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "AccessType",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "access",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                (v0 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "profile",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Profile",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        (v1 /*: any*/),
                                        (v2 /*: any*/),
                                        (v3 /*: any*/),
                                        (v4 /*: any*/),
                                        (v5 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "role",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "cart",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Cart",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "eventId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "eventHostFirstName",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "email",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v6 /*: any*/),
                                (v7 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hasSSOAccount",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shoppingWithCeoUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v8 /*: any*/),
                                        (v0 /*: any*/),
                                        (v9 /*: any*/),
                                        (v7 /*: any*/)
                                    ]
                                },
                                (v9 /*: any*/),
                                (v8 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": "DropDownAutoCompleteData",
                                    "name": "autoCompleteData",
                                    "storageKey": "autoCompleteData(ceoId:\"none\",first:25,searchCEOS:false,searchEvents:false,searchProducts:false)",
                                    "args": (v10 /*: any*/),
                                    "concreteType": "AutoCompleteEntryConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "AutoCompleteEntryEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "cursor",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "AutoCompleteDataEntry",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "isProduct",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v0 /*: any*/),
                                                        (v1 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "ceoId",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "isEvent",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "isCEO",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "routePath",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "primaryLabel",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "secondaryLabel",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "productCategory",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "__typename",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "pageInfo",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "endCursor",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "hasNextPage",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedHandle",
                                    "alias": "DropDownAutoCompleteData",
                                    "name": "autoCompleteData",
                                    "args": (v10 /*: any*/),
                                    "handle": "connection",
                                    "key": "DropDownAutoComplete_DropDownAutoCompleteData",
                                    "filters": [
                                        "ceoId",
                                        "inputValue",
                                        "searchCEOS",
                                        "searchEvents",
                                        "searchProducts"
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "ceo",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        (v8 /*: any*/),
                                        (v7 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "disableJoinMyTeam",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v6 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "trinityDealerId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "profile",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Profile",
                                            "plural": false,
                                            "selections": [
                                                (v1 /*: any*/),
                                                (v5 /*: any*/),
                                                (v2 /*: any*/),
                                                (v3 /*: any*/),
                                                (v4 /*: any*/),
                                                (v0 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "password",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "customUrl",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "mobilePhone",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hasGoogleLogin",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hasFacebookLogin",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isResettingPassword",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "preferredCustomerCeoAccountId",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shippingAddressDefault",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Address",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        (v6 /*: any*/),
                                        (v7 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "street",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "addressLineOne",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "addressLineTwo",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v2 /*: any*/),
                                        (v3 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "addressId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v4 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "paymentDefault",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "StripePayment",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "name",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "expMonth",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "expYear",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "last4",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "paymentId",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "userInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "profile",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Profile",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        (v1 /*: any*/),
                                        (v3 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "personality",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v5 /*: any*/)
                                    ]
                                },
                                (v0 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "queries_MyAccountPage_Query",
            "id": null,
            "text": "query queries_MyAccountPage_Query {\n  viewer {\n    id\n    ...MyAccountPage_viewer\n  }\n}\n\nfragment MyAccountPage_viewer on Viewer {\n  id\n  isLoggedIn\n  ...FileUploadForm_viewer\n  userInfo {\n    profile {\n      id\n      image\n      state\n      personality\n      summary\n    }\n    id\n  }\n  user {\n    id\n    ...ShopWithCeoDialog_user\n    publicId\n    userId\n    password\n    firstName\n    lastName\n    customUrl\n    email\n    mobilePhone\n    role\n    hasSSOAccount\n    hasGoogleLogin\n    hasFacebookLogin\n    isResettingPassword\n    permissions {\n      id\n      oneCommerce {\n        id\n        ceo {\n          access\n        }\n      }\n    }\n    preferredCustomerCeoAccountId\n    shoppingWithCeoUser {\n      firstName\n      userId\n      id\n    }\n    profile {\n      id\n      image\n      city\n      state\n      zip\n      summary\n    }\n    shippingAddressDefault {\n      id\n      lastName\n      firstName\n      street\n      addressLineOne\n      addressLineTwo\n      city\n      state\n      addressId\n      zip\n    }\n    paymentDefault {\n      id\n      name\n      expMonth\n      expYear\n      last4\n      paymentId\n    }\n  }\n}\n\nfragment FileUploadForm_viewer on Viewer {\n  id\n  user {\n    id\n    userId\n    profile {\n      id\n      image\n    }\n  }\n}\n\nfragment ShopWithCeoDialog_user on User {\n  role\n  id\n  cart {\n    id\n    eventId\n  }\n  ...ShopWithCeoProfile_user\n  ceo {\n    id\n    userId\n    firstName\n    disableJoinMyTeam\n    lastName\n    trinityDealerId\n    profile {\n      image\n      summary\n      city\n      state\n      zip\n      id\n    }\n  }\n}\n\nfragment ShopWithCeoProfile_user on User {\n  ...EventsDropDown_user\n  shoppingWithCeoUser {\n    userId\n    firstName\n    id\n  }\n}\n\nfragment EventsDropDown_user on User {\n  ...DropDownAutoComplete_user\n}\n\nfragment DropDownAutoComplete_user on User {\n  ...AuthDialog_user\n  id\n  userId\n  publicId\n  permissions {\n    id\n    oneCommerce {\n      id\n      ceo {\n        access\n      }\n    }\n  }\n  shoppingWithCeoUser {\n    publicId\n    id\n  }\n  DropDownAutoCompleteData: autoCompleteData(first: 25, ceoId: \"none\", searchCEOS: false, searchEvents: false, searchProducts: false) {\n    edges {\n      cursor\n      node {\n        id\n        isCEO\n        image\n        ceoId\n        isEvent\n        isProduct\n        routePath\n        primaryLabel\n        secondaryLabel\n        productCategory\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AuthDialog_user on User {\n  id\n  role\n  email\n  lastName\n  firstName\n  hasSSOAccount\n  shoppingWithCeoUser {\n    userId\n    id\n  }\n  cart {\n    id\n    eventId\n    eventHostFirstName\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '3dd8b30732ea310b368edb671c848892';
export default node;
